<template lang="pug">
  v-form(autocomplete='false' v-model='formulario_validado')
    v-row
      v-col
        v-menu(v-model='creationDateDialog' :close-on-content-click='true' :nudge-right='40' transition='scale-transition' offset-y min-width='290px' )
          template(v-slot:activator='{ on }')
            v-text-field(v-model='Datos.fecha_de_emision' label='Fecha de emisión' readonly v-on='on' :disabled='Datos.isAnnulled || Datos.isClose')
          v-date-picker(:rules='[Rules.required]' v-model='Datos.fecha_de_emision' @input='datePicker = false' )
      v-col
        v-menu(v-model='datePicker_fecha_de_traslado' :close-on-content-click='true' :nudge-right='40' transition='scale-transition' offset-y min-width='290px')
          template(v-slot:activator='{ on }')
            v-text-field(v-model='Datos.fecha_de_inicio_de_traslado' label='Fecha de incio de traslado' readonly v-on='on')
          v-date-picker(v-model='Datos.fecha_de_inicio_de_traslado' @input='datePicker_fecha_de_traslado = false')

    v-row
      v-col
        v-autocomplete(:rules='[Rules.required]' v-model="Datos.transportista_denominacion" item-value='denominacion' item-text='denominacion' label='Vehículo' :items="Registro_de_transportistas"  )
        v-autocomplete(:rules='[Rules.required]' v-model="Datos.transportista_placa_numero" item-text='denominacion' label='Placa' :items="Datos.transportista_lista_de_placas" return-object )
      v-col

        v-autocomplete(
          :rules='[Rules.required]' 
          v-model.sync="Datos.conductor_denominacion" 
          item-text='conductor_denominacion' 
          label='Conductor' :items="DriverRecord" 
          item-value='conductor_denominacion'
          @change=' Datos.conductor_documento_tipo = DriverRecord.filter(item => item.conductor_denominacion == Datos.conductor_denominacion)[0].conductor_documento_tipo; Datos.conductor_documento_numero = DriverRecord.filter(item => item.conductor_denominacion == Datos.conductor_denominacion)[0].conductor_documento_numero '
        )

        
    v-row 
      v-col   
        v-text-field(type='number' label='Nº de Bultos' v-model.number='Datos.numero_de_bultos')
      v-col 
        v-text-field(type='number' label='Peso bruto total' v-model.number='Datos.peso_bruto_total') 
    
     
    v-row
      v-col(v-if='Datos.warehouse[0] && Datos.warehouse[0].direcciones')
        v-autocomplete.pl-2( 
          :rules='[Rules.object]' 
          v-model="Datos.punto_de_partida_direccion" 
          item-text='ubicación' 
          label='Punto de origen' 
          :items="Datos.warehouse[0].direcciones" 
          item-value='ubicación' 
        )
        v-chip(small)
          strong Ubigeo:
          span( v-if='Datos.warehouse[0].direcciones' v-html='Datos.punto_de_partida_ubigeo = Datos.warehouse[0].direcciones.filter(item => item.ubicación == Datos.punto_de_partida_direccion)[0].ubigeo')
      v-col  
        v-autocomplete( v-if='Datos.lista_de_direcciones && Datos.lista_de_direcciones.length>0' :rules='[Rules.required]' label='Punto de llegada' v-model='Datos.punto_de_llegada_direccion' :items='Datos.lista_de_direcciones' item-text='ubicación' item-value='ubicación')
        v-chip(small)
          strong Ubigeo:
          span( v-if='Datos.lista_de_direcciones && Datos.lista_de_direcciones.length>0' v-html='Datos.punto_de_llegada_ubigeo = Datos.lista_de_direcciones.filter(item => item.ubicación == Datos.punto_de_llegada_direccion)[0].ubigeo')
    v-row
      v-col
        v-textarea( value='Observaciones' label='Observaciones' v-model='Datos.observaciones' )

</template>
<script>
import {mapGetters, mapState} from 'vuex'
export default {
  data: ()=>({
    formulario_validado: false,
    datePicker_fecha_de_traslado: false,
    creationDateDialog:false,
    conductor: {}
  }),
  props: {
    modelo: String
  },
  watch: {

    'Datos.transportista_denominacion'(){
      if(!this.Datos.transportista_denominacion) return
      this.Datos.tipo_de_transporte = this.Registro_de_transportistas.filter(item => item.denominacion == this.Datos.transportista_denominacion)[0].tipo_de_transporte
      this.Datos.transportista_documento_tipo = this.Registro_de_transportistas.filter(item => item.denominacion == this.Datos.transportista_denominacion)[0].documento_tipo
      this.Datos.transportista_documento_numero = this.Registro_de_transportistas.filter(item => item.denominacion == this.Datos.transportista_denominacion)[0].documento_numero
      this.Datos.transportista_lista_de_placas = this.Registro_de_transportistas.filter(item => item.denominacion == this.Datos.transportista_denominacion)[0].placas
      this.Datos.transportista_placa_numero = this.Datos.transportista_lista_de_placas[0] || ''
    },
  
  },
  computed:{
    transportista_lista_de_placas(){
      console.log('o')
      if(!this.Datos.transportista_denominacion) this.Datos.transportista_lista_de_placas = this.Registro_de_transportistas.filter(item => item.denominacion == this.Datos.transportista_denominacion)[0].placas
    },
    ...mapGetters({
      VehicleRecord: 'Vehicle/record',
      DriverRecord: 'Driver/record',
      Registro_de_transportistas: 'Transportista/registro',
    }),
    Datos() { return this.$store.state[this.modelo].data },
    Rules() { return this.$store.state.Helpers.rules},
     
   
  }
}
</script>

